"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _reactDom = _interopRequireDefault(require("react-dom")),
    _memoizeOne = _interopRequireDefault(require("memoize-one")),
    _Image = _interopRequireDefault(require("../../../../Image")),
    _Icon = _interopRequireDefault(require("../../../../Icon")),
    _ActionPopup = _interopRequireDefault(require("../../../../ActionPopup")),
    _onEnterPressed = _interopRequireDefault(require("../../../../../common/utils/onEnterPressed")),
    _UserDetails = _interopRequireDefault(require("./UserDetails")),
    _listItem = require("../styles/listItem");

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      (0, _defineProperty2["default"])(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

function _createSuper(a) {
  return function () {
    var b,
        c = (0, _getPrototypeOf2["default"])(a);

    if (_isNativeReflectConstruct()) {
      var d = (0, _getPrototypeOf2["default"])(this).constructor;
      b = Reflect.construct(c, arguments, d);
    } else b = c.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, b);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

var ListItem = function (a) {
  function b(a) {
    var d;
    return (0, _classCallCheck2["default"])(this, b), d = c.call(this, a), d.withNoEventPropagation = (0, _memoizeOne["default"])(function (a) {
      return function (b) {
        b.stopPropagation(), b.preventDefault(), a(b);
      };
    }), d.wrapPopupOptionsWithStopEvent = (0, _memoizeOne["default"])(function (a) {
      return a.map(function (a) {
        return _objectSpread({}, a, {
          action: d.withNoEventPropagation(a.action)
        });
      });
    }), d.onClick = function (a) {
      return d.withNoEventPropagation(function (b) {
        var c = d.state.actionBtnRef;
        c && c.contains(b.target) || !a || a(b);
      });
    }, d.setActionPopupRef = (0, _memoizeOne["default"])(function (a) {
      a && d.setState({
        actionBtnRef: _reactDom["default"].findDOMNode(a)
      });
    }), d.state = {}, d;
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "render",
    value: function render() {
      var a = this.props,
          b = a.children,
          c = a.onClick,
          d = a.hideImage,
          e = a.defaultImage,
          f = a.defaultImageIcon,
          g = a.actionPopupOptions,
          h = a.className;
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])("list-item", (0, _listItem.LIST_ITEM)({
          onClick: c
        }), h),
        onClick: this.onClick(c),
        role: "button",
        onKeyDown: (0, _onEnterPressed["default"])({
          onClick: this.onClick(c)
        }),
        tabIndex: 0
      }, !d && _react["default"].createElement(_Image["default"], {
        className: "icon",
        imageUrl: e,
        defaultImageIcon: f,
        width: "90px",
        height: "90px"
      }), b, g ? _react["default"].createElement(_ActionPopup["default"], {
        options: this.wrapPopupOptionsWithStopEvent(g),
        popupBtn: _react["default"].createElement(_Icon["default"], {
          name: "options",
          color: "regent"
        }),
        ref: this.setActionPopupRef
      }) : null);
    }
  }]), b;
}(_react.Component);

ListItem.UserDetails = _UserDetails["default"];
var _default = ListItem;
exports["default"] = _default;